const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    '@global': {
      body: {
        color: 'white',
      },
      h2: {
        color: 'white',
        fontSize: '30px',
      },
      '.ant-form-item-label>label, .ant-form': {
        color: 'white',
      },
    },
    centeredContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      '& .ant-form-item': {
        width: '100%',
      },
    },
    formContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },

    formItemLabel: {
      color: theme.secondaryTextColor,
      fontWeight: 400,
    },
    availableWithdrawAmountRow: {
      color: 'white',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    inputSection: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      textAlign: 'end',
    },
    antDesignInput: {
      '&.ant-input': {
        color: 'white',
        textAlign: 'end',
        width: '50%',
        fontSize: 36,
        fontWeight: 700,
        textDecoration: 'underline',
        textDecorationColor: '#3F95ED',
      },
    },
    unitLabel: {
      color: 'white',
      fontSize: 16,
      fontWeight: 500,
      width: '50%',
      lineHeight: '50px',
      textAlign: 'start',
    },
    withdrawalInfo: {
      color: theme.secondaryTextColor,
      fontWeight: 400,
      margin: '10px 0',
    },
    customSelect: {height: 50, alignItems: 'center', display: 'flex'},
    customInput: {height: 50, alignItems: 'center', display: 'flex'},
    rightCol: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    video: {
      width: '100%',
    },
    withdrawInfoSection: {
      padding: '10px 0',
      width: '100%',
      borderTop: '1px solid #383D46',
    },
    // maxButton: {borderRadius: 5, width: 57, height: 40, marginRight: -6},
    buttonArea: {
      marginTop: 'auto',
      width: '100%',
      borderTop: `1px solid ${theme.borderColor}`,
      paddingTop: 15,
    },
    withdrawButton: {
      width: '100%',
      display: 'block',
      margin: 'auto',
      height: 50,
      borderRadius: 10,
    },
    bottomSection: {
      position: 'absolute',
      width: '100%',
      bottom: -13,
    },
    divider: {
      '&.ant-divider-horizontal': {
        opacity: 0.5,
        borderTopColor: 'rgb(255 255 255 / 10%)',
        margin: 0,
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
